import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectDataTableService {
  private searchText = "";
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }
  setSearchText(value) {
    this.searchText = value;
  }
  getSearchText() {
    return this.searchText;
  }
  getProjectProfilesByStatuses(searchText, searchField, isProfileCompleted, from, size) {
    const url = `${this.apiUrl}Competency/GetProjectProfileStatus?search=${searchText}&searchField=${searchField}&isProfileCompleted=${isProfileCompleted}&from=${from}&size=${size}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getProjectCompletedCounts() {
    const url = `${this.apiUrl}Competency/GetProjectProfileCount`;
    return this.http.get<any>(url, this.httpOptions);
  }
}
